// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDzJCkl_n_W2nS9w9yF6xVKEanU_QsXfQA",
    authDomain: "facilityadminpanel.firebaseapp.com",
    projectId: "facilityadminpanel",
    storageBucket: "facilityadminpanel.appspot.com",
    messagingSenderId: "603228794950",
    appId: "1:603228794950:web:0f070343caac9806f65a47",
    measurementId: "G-S4QNB6EDZ1"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
